import styled from "styled-components";
import { ColorsDomains } from "../../theme/styled";

export const SituationCardContainer = styled.div<{ color: string }>`
  align-items: center;
  display: flex;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grey100};
  padding: 32px;
  border-radius: 4px;
  transition: all 0.3s ease;
  box-sizing: border-box;

  &:hover {
    border: 4px solid
      ${({ theme, color }) =>
        theme.colors.domains[color as keyof ColorsDomains]};
  }
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 90%;
`;

export const BoutonContainer = styled.div`
  width: 10%;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
`;
